const initialState = {
    responseAgencyIncentiveList: {},
    responseAgencyIncentiveDetail: null,
    responseCreate: null,
    responseUpdate: null,
    loading: false,
    error: null,
};

export default function agencyIncentiveReducer(state = initialState, action) {
    switch (action.type) {

        // LISTADO

        case 'AGENCY_INCENTIVE_LIST_REQUEST':
            return {
                ...state,
                loading: true,
                error: null,
            };

        case 'AGENCY_INCENTIVE_LIST_RESPONSE':
            return {
                ...state,
                loading: false,
                responseAgencyIncentiveList: action.value,
            };

        case 'AGENCY_INCENTIVE_ERROR':
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        // DETALLE

        case 'AGENCY_INCENTIVE_DETAIL_REQUEST':
            return {
                ...state,
                loading: true,
                error: null,
            };

        case 'AGENCY_INCENTIVE_DETAIL_RESPONSE':
            return {
                ...state,
                loading: false,
                responseAgencyIncentiveDetail: action.value,
            };

        // CREATE

        case 'AGENCY_INCENTIVE_CREATE_REQUEST':
            return {
                ...state,
                loading: true,
                error: null,
                responseCreate: null,
            };

        case 'AGENCY_INCENTIVE_CREATE_RESPONSE':
            return {
                ...state,
                loading: false,
                responseCreate: action.value,
            };

        case 'AGENCY_INCENTIVE_CREATE_ERROR':
            return {
                ...state,
                loading: false,
                error: action.error,
            };


        // UPDATE

        case 'AGENCY_INCENTIVE_UPDATE_REQUEST':
            return {
                ...state,
                loading: true,
                error: null,
                responseUpdate: null,
            };

        case 'AGENCY_INCENTIVE_UPDATE_RESPONSE':
            return {
                ...state,
                loading: false,
                responseUpdate: action.value,
            };

        case 'AGENCY_INCENTIVE_UPDATE_ERROR':
            return {
                ...state,
                loading: false,
                error: action.error,
            };

        case 'AGENCY_INCENTIVE_CLEAR_STATE':
            return {
                ...state,
                error: null,
                responseCreate: null,
                responseUpdate: null,
            };

        default:
            return state;
    }
}
